/**
 * Cum se compară două nume din echipă: fără diacritice, fără „Dr.", fără
 * majuscule și spații în plus. „Dr. Ion Rusu" și „ion  rușu" sunt același om
 * pentru ochiul care citește calendarul.
 */
export function staffNameKey(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/^\s*dr\.?\s+/, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Colegul activ care poartă deja numele scris, dacă există — altul decât cel
 * editat. Doar un avertisment: doi oameni pot avea, rar, același nume; adresa
 * de email e cea pe care serverul o refuză la dublură.
 */
export function sameNameMember<T extends { id: string; name: string; active?: boolean }>(
  name: string,
  staff: readonly T[],
  exceptId?: string,
): T | null {
  const key = staffNameKey(name);
  if (!key) return null;
  return (
    staff.find((s) => s.id !== exceptId && s.active !== false && staffNameKey(s.name) === key) ??
    null
  );
}
